var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

import React, { useState, useRef } from 'react';
import t from 'prop-types';
import { is_touch_device } from './../util';
var ON_PRESIONADO = is_touch_device() ? "onTouchStart" : "onClick";

function Boton(_ref) {
  var _eventos;

  var herramientaId = _ref.herramientaId,
      grupo = _ref.grupo,
      presionado = _ref.presionado,
      valor = _ref.valor,
      style = _ref.style,
      extraClases = _ref.extraClases,
      onPresionado = _ref.onPresionado,
      children = _ref.children;

  var _useState = useState(true),
      noOver = _useState[0],
      setNoOver = _useState[1];

  var rootRef = useRef();

  function handleOver(e) {
    var newNoOver = e.target !== rootRef.current;

    if (noOver !== newNoOver) {
      setNoOver(noOver);
    }
  }

  function handlePresionado(e) {
    if (e.target !== rootRef.current) {
      return;
    }

    e.preventDefault();
    e.stopPropagation();
    onPresionado && onPresionado(herramientaId, grupo, valor);
  }

  var clases = ['botonHerramienta', presionado ? 'activado' : '', noOver ? 'noHover' : ''].concat(extraClases);
  var eventos = (_eventos = {}, _eventos[ON_PRESIONADO] = handlePresionado, _eventos.onMouseOver = handleOver, _eventos);
  return React.createElement('div', _extends({
    id: 'herramienta' + herramientaId,
    className: clases.join(' '),
    style: style,
    ref: rootRef
  }, eventos), children);
}

Boton.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Identificador de la herramienta */
  herramientaId: t.string.isRequired,

  /** Grupo de la barra de herramientas al que pertenece el boton */
  grupo: t.string,

  /** Indica si el boton esta presionado inicialmente o no */
  presionado: t.bool,

  /** Valor asociado al botón si procede */
  valor: t.any,

  /** estilo css  */
  style: t.object,

  /** clases extra */
  extraClases: t.array,

  /**
   * Evento que se lanza al pinchar sobre el boton. Es de la forma:<br/>
   * Un botón ya presionado no lanza ningún evento.
   * <code>(id, grupo, valor) => {...}</code>
   */
  onPresionado: t.func,
  children: t.any
} : {};
Boton.defaultProps = {
  grupo: 'General',
  presionado: false,
  style: {},
  clases: [],
  extraClases: [],
  onPresionado: function onPresionado(id, grupo, valor) {}
};
export default Boton;